export class SupplierRequestsModel {
  id: number;
  requestId: number;
  requestorId: number;
  requestorName: string;
  requestStatusName: string;
  requestNumber: string;
  requestStatusId: number;
  fmRequestType: string;
  companyName: string;
  supCompanyName: string;
  supCompanyDescription: string;
  postCode: string;
  businessPhone: string;
  faxNumber: string;
  contactName: string;
  street: string;
  city: string;
  email: string;
  webPage: string;
  linkDescription: string;
  otherBusinessType: string;
  businessNames: string[];
  businessIds: number[];
  countryName: string;
  countryId: number;

}




// WEBPACK FOOTER //
// ./src/app/core/models/supplier-requests.ts